import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { CalendarCheck2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LeaseRenew() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [done, setDone] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    axios.get(`${API}/public/lease-renew/${token}`).then((r) => setInfo(r.data))
      .catch((e) => setError(e.response?.data?.detail || "This link is no longer valid"));
  }, [token]);
  const confirm = async () => {
    setBusy(true);
    try { const r = await axios.post(`${API}/public/lease-renew/${token}`); setDone(r.data); }
    catch (e) { setError(e.response?.data?.detail || "Renewal failed"); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[#f6f4ef] flex items-center justify-center p-6">
      <div className="bg-white rounded-3xl border border-slate-100 p-8 max-w-md w-full shadow-sm" data-testid="lease-renew-page">
        <CalendarCheck2 className="w-8 h-8 text-teal-700 mb-4" />
        {error && <p className="text-rose-700 text-sm" data-testid="lease-renew-error">{error}</p>}
        {!error && !info && <p className="text-slate-400 text-sm">Loading…</p>}
        {done && (
          <div data-testid="lease-renew-done">
            <h1 className="font-serif text-2xl mb-2">Lease renewed</h1>
            <p className="text-sm text-slate-600">{done.property_name} now runs until <strong>{done.new_end}</strong>.</p>
          </div>
        )}
        {info && !done && !error && (
          <>
            <h1 className="font-serif text-2xl mb-2">Renew {info.property_name}?</h1>
            <p className="text-sm text-slate-600 mb-6">
              The lease currently ends on <strong>{info.current_end}</strong>. Confirming extends it by 12 months to <strong data-testid="lease-renew-new-end">{info.new_end}</strong>.
            </p>
            <button onClick={confirm} disabled={busy} data-testid="lease-renew-confirm"
              className="w-full rounded-full bg-teal-700 hover:bg-teal-800 text-white py-3 text-sm transition-colors disabled:opacity-60">
              {busy ? "Renewing…" : "Confirm 12-month renewal"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
